var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceBatteryLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Battery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Service-BatteryLarge",
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3059571,12.3931351 C39.9628113,12.3931351 41.3059571,13.7362808 41.3059571,15.3931351 L41.3059571,35.8407593 C41.3059571,37.4976135 39.9628113,38.8407593 38.3059571,38.8407593 L9.6940429,38.8407593 C8.03718865,38.8407593 6.6940429,37.4976135 6.6940429,35.8407593 L6.6940429,15.3931351 C6.6940429,13.7362808 8.03718865,12.3931351 9.6940429,12.3931351 L38.3059571,12.3931351 Z M24,17.6169472 C19.581722,17.6169472 16,21.1986692 16,25.6169472 C16,30.0352252 19.581722,33.6169472 24,33.6169472 C28.418278,33.6169472 32,30.0352252 32,25.6169472 C32,21.1986692 28.418278,17.6169472 24,17.6169472 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(10.418558, 6.918355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0 L4.41874278,0 C4.97102753,-1.01453063e-16 5.41874278,0.44771525 5.41874278,1 L5.41874278,3.6 L5.41874278,3.6 L0,3.6 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7441413,0 L26.1628841,0 C26.7151688,-3.23497668e-16 27.1628841,0.44771525 27.1628841,1 L27.1628841,3.6 L27.1628841,3.6 L21.7441413,3.6 L21.7441413,1 C21.7441413,0.44771525 22.1918566,-1.20591542e-16 22.7441413,0 Z",
    id: "Rectangle-Copy-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.8423299,31.1418026 L22.8423299,27.2746172 C22.8423299,26.9984749 22.6184723,26.7746172 22.3423299,26.7746172 L21.3603231,26.7746172 C21.0841807,26.7746172 20.8603231,26.5507596 20.8603231,26.2746172 C20.8603231,26.1925468 20.8805253,26.1117382 20.9191467,26.0393231 L24.2164936,19.8567976 C24.346443,19.6131426 24.6493092,19.5209659 24.8929642,19.6509152 C25.0558959,19.7378122 25.1576701,19.9074357 25.1576701,20.0920917 L25.1576701,23.9592771 C25.1576701,24.2354195 25.3815277,24.4592771 25.6576701,24.4592771 L26.6396769,24.4592771 C26.9158193,24.4592771 27.1396769,24.6831347 27.1396769,24.9592771 C27.1396769,25.0413475 27.1194747,25.1221561 27.0808533,25.1945712 L23.7835064,31.3770968 C23.653557,31.6207518 23.3506908,31.7129285 23.1070358,31.5829791 C22.9441041,31.4960822 22.8423299,31.3264586 22.8423299,31.1418026 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceBatteryLarge);
export default __webpack_public_path__ + "static/media/Service-BatteryLarge.e68a79bc2541e8c50f55bfded2badae7.svg";
export { ForwardRef as ReactComponent };